module.exports = __webpack_public_path__ + "img/b4.6f8a3e5.png";